import { render, staticRenderFns } from "./VisaRejectModal.vue?vue&type=template&id=f2d50f96&scoped=true&"
import script from "./VisaRejectModal.vue?vue&type=script&lang=js&"
export * from "./VisaRejectModal.vue?vue&type=script&lang=js&"
import style0 from "./VisaRejectModal.vue?vue&type=style&index=0&id=f2d50f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d50f96",
  null
  
)

export default component.exports